<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record.objId"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    size="middle"
    :row-selection="rowSelection"
  >
    <template slot="isMembers" slot-scope="text, isMembers">
      <a-switch
        :checked="isMembers.show === 1 ? true : false"
        checked-children="是"
        un-checked-children="否"
        @change="onChange(isMembers)"
      />
    </template>
    <template slot="location" slot-scope="location">
      <span>{{
        location === 1 ? "首页" : location === 2 ? "详情" :location === 3 ? "通用" :  location === 4 ? "兑换商城页" : location === 5 ? "福利群二维码" : ""
      }}</span>
    </template>
    <template slot="slideshowUrl" slot-scope="slideshowUrl">
      <img :src="slideshowUrl" alt="" />
    </template>
    <template slot="operate" slot-scope="text, operate">
      <a
        href="javascript:;"
        @click="
          topage(`/home/carouselManagement/newCarousels?objId=${operate.objId}`)
        "
        >编辑</a
      >
      <a href="javascript:;" @click="del(operate)">删除</a>
    </template>
  </a-table>
</template>
<script>
import {
  carouseList,
  delCarouseList,
  storeCarouseEdit,
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "主图",
    dataIndex: "slideshowUrl",
    align: "center",
    scopedSlots: { customRender: "slideshowUrl" },
    sorter: true,
  },
  {
    title: "展示位置",
    dataIndex: "location",
    align: "center",
    scopedSlots: { customRender: "location" },
  },
  {
    title: "序号",
    align: "center",
    dataIndex: "sortNum",
  },
  {
    title: "是否显示",
    align: "center",
    dataIndex: "isMembers",
    scopedSlots: { customRender: "isMembers" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getCarouseListData();
    this.$emit("dels", this.ids);
  },
  props: ["formInline"],
  methods: {
    // 分页列表
    getCarouseListData() {
      carouseList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.data.count;
        this.data = res.data.data;
      });
    },

    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      carouseList({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data.data;
        console.log(res);
        this.loading = false;
      });
    },
    // 删除
    del(row) {
      console.log(row);
      delCarouseList([row.objId]).then((res) => {
        console.log(res);
        message.success("删除成功");
        this.getCarouseListData();
      });
    },
    query() {
      this.loading = true;
      carouseList({
        location: this.formInline.location,
        limit: 10,
        page: 1,
      }).then((res) => {
        this.loading = false;
        this.data = res.data.data;
        this.pagination.total = res.data.count;
      });
    },
    onChange(row) {
      console.log(row);
      if (row.show === 1) {
        storeCarouseEdit({ objId: row.objId, show: 0 }).then((res) => {
          this.getCarouseListData();
          message.success(res.data);
        });
      } else {
        storeCarouseEdit({ objId: row.objId, show: 1 }).then((res) => {
          this.getCarouseListData();
          message.success(res.data);
        });
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setids", selectedRowKeys);
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/carouselManagement/carouselManagementContent.vue